




import { Component, Prop, Vue, Watch } from "vue-property-decorator";

declare function require(x: string): any;

@Component
export default class SVG extends Vue {
  @Prop({default:''}) public name:string;
  @Prop({default:null}) public width:number;
  @Prop({default:null}) public height:number;

  public get svg() {    
    return () => import(`@/assets/${this.name}.svg`);
  }

  public get path(){
    return require(`@/assets/${this.name}.svg`);
  }
}
